import React, { useState, useEffect } from "react";
import { PageHeader, Tabs, Row, Col, DatePicker, Table, Statistic } from "antd";
import {
  Chart,
  Line,
  Point,
  Tooltip,
  Legend,
  Axis,
  Guide,
  Geom,
} from "bizcharts";
import { ScreenSize } from "utils/constants";
import { min } from "moment";
import { jsx } from "@emotion/core";
import Locale from "react-intl-universal";

const LineChart = (props) => {
  const [data, setData] = useState({});
  // [
  // {
  //   month: 'Jan',
  //   newAdvisee: 7
  // },
  // {
  //   month: 'Feb',
  //   newAdvisee: 6.9
  // },
  // {
  //   month: 'Mar',
  //   newAdvisee: 9.5
  // },
  // {
  //   month: 'Apr',
  //   newAdvisee: 14.5
  // },
  // {
  //   month: 'May',
  //   newAdvisee: 11.9
  // },
  // {
  //   month: 'Jun',
  //   newAdvisee: 15.2
  // },
  // {
  //   month: 'Jul',
  //   newAdvisee: 17
  // },
  // {
  //   month: 'Aug',
  //   newAdvisee: 16.6
  // },
  // {
  //   month: 'Sep',
  //   newAdvisee: 23.3
  // },
  // {
  //   month: 'Oct',
  //   newAdvisee: 18.3
  // },
  // {
  //   month: 'Nov',
  //   newAdvisee: 13.9
  // },
  // {
  //   month: 'Dec',
  //   newAdvisee: 9.6
  // }
  // ]

  useEffect(() => {
    if (props.data) {
      setData(props.data);
      console.log("props", props);
    }
  }, [props.data]);

  const scale = {
    newAdvisee: { min: 0 },
    // type: {
    //   formatter: (v) => {
    //     return {
    //       Sales: 'Sales',
    //       Target: 'Target'
    //     }[v];
    //   }
    // }
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const LineChartLabel = (
    chartData,
    title,
    ChartTitleX,
    ChartTitleY,
    dataX,
    dataY
  ) => {
    var scale;

    switch (dataY) {
      case "newAdvisee":
        scale = {
          newAdvisee: { min: 0 },
        };
        break;

      case "advisee":
        scale = {
          advisee: { min: 0 },
        };
        break;

      case "deals":
        scale = {
          deals: { min: 0 },
        };
        break;

      case "clients":
        scale = {
          clients: { min: 0 },
        };
        break;

      default:
        break;
    }

    return (
      <div
        style={{
          // backgroundColor: '#fff',
          padding: 16,
          border: "1px solid rgba(0,0,0,0.15)",
          marginBottom: 8,
        }}
      >
        <h1 style={{ textAlign: "left", fontWeight: "bold", fontSize: 18 }}>
          {title}
        </h1>

        <div
          style={{
            position: "absolute",
            left: ChartTitleY === "New Advisee" ? -16 : 0,
            top: "50%",
            transform: "rotate(270deg)",
            fontWeight: "500",
          }}
        >
          {ChartTitleY}
        </div>

        <div
          style={{
            position: "absolute",
            left: "50%",
            bottom: 24,
            fontWeight: "500",
          }}
        >
          {ChartTitleX}
        </div>

        <Chart
          scale={scale}
          // padding={[50, 20, 60, 80]}
          padding={[24, 0, 60, 40]}
          autoFit
          height={400}
          data={chartData}
          // data={data}
          // data={props.data}
          // interactions={['element-active']}
        >
          {/* <Axis
            name="newAdvisee"
            label={{
              formatter: (val) => numberWithCommas(val)
            }}
          /> */}
          <Point
            position={`${dataX}*${dataY}`}
            // color="newAdvisee"
            color={"#722ed1"}
            shape="circle"
          />

          <Line
            shape="smooth"
            color={"#722ed150"}
            position={`${dataX}*${dataY}`}
            label={dataY}
            // label="newAdvisee"
            // position="month*newAdvisee"
            // color={'month'}
            // label={[
            //   'newAdvisee*type',
            //   (val, type) => {
            //     // var res = 'RM\xa0' + numberWithCommas(val);

            //     // console.log(val);
            //     // console.log(val, "val");
            //     if (window.innerWidth > ScreenSize.xs) {
            //       return {
            //         content: val,
            //         // content: res,
            //         style: {
            //           fill: type === 'Target' ? '#40a9ff' : '#722ed1',
            //           fontSize: 12
            //           // fontWeight: "bold"
            //         }
            //       };
            //     } else {
            //       return null;
            //     }
            //   }
            // ]}
          />

          {/* <Guide>
            <Guide.Text
              top={false}
              content={`Sales Target RM ${numberWithCommas(salesTarget)}`}
              style={{
                fontSize: 14,
                fill: '#62daab'
              }}
              position={(xScale, yScale) => {
                return ['35%', '8%'];
              }}
            />
          </Guide> */}

          {/* <Guide>
          <Line
            // {boolean} 指定 guide 是否绘制在 canvas 最上层，默认为 false, 即绘制在最下层
            start={{ month: "Jun", revenue: 2000000 }} // {object} | {function} | {array} 辅助线结束位置，值为原始数据值，支持 callback
            end={{ month: "Jun", revenue: 2000000 }} // 同 start
            lineStyle={{
              stroke: "#999", // 线的颜色
              lineDash: [0, 2, 2], // 虚线的设置
              lineWidth: 3 // 线的宽度
            }} // {object} 图形样式配置 https://bizcharts.net/products/bizCharts/api/graphic#线条样式
            text={{
              position: "start", // 'start' | 'center' | 'end' | '39%' | 0.5 文本的显示位置
              autoRotate: true, // {boolean} 是否沿线的角度排布，默认为 true
              style: {
                fill: "red"
              }, // {object}文本图形样式配置,https://bizcharts.net/products/bizCharts/api/graphic#文本属性
              offsetX: 20, // {number} x 方向的偏移量
              offsetY: -10, // {number} y 方向的偏移量
              content: "预期收益趋势线" // {string} 文本的内容
            }}
          />
        </Guide> */}

          <Tooltip shared showCrosshairs>
            {(title, items) => {
              return (
                <div style={{ padding: 10 }}>
                  {items.map((value, index) => {
                    // console.log('value', value);
                    // console.log(items);
                    return (
                      <div key={index + 1}>
                        <Row align="middle">
                          <Col
                            style={{
                              backgroundColor: "#722ed1",
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              marginRight: 12,
                            }}
                          />
                          <Col>
                            <span>
                              {value.title} : {value.value}
                              {/* {value.title} : {value.data.newAdvisee} */}
                            </span>
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                </div>
              );
            }}
          </Tooltip>
          {/* <Legend
            background={{
              padding: [0, 0, -24, 0],
              style: {
                fill: '#fff',
                stroke: '#fff'
              }
            }}
          /> */}
        </Chart>
      </div>
    );
  };

  return (
    <div>
      <Row justify="space-between" gutter={8} style={{ marginBottom: 16 }}>
        <Col xs={24} md={24} xl={12}>
          {LineChartLabel(
            data.newAdvisee,
            Locale.get("Dashboard.lineChart.chartTitle_1"),
            Locale.get("Dashboard.lineChart.xAxisTitle"),
            Locale.get("Dashboard.lineChart.yAxisTitle_1"),
            "month",
            "value"
            // "newAdvisee"
          )}
        </Col>
        <Col xs={24} md={24} xl={12}>
          {LineChartLabel(
            data.totalAdvisee,
            Locale.get("Dashboard.lineChart.chartTitle_2"),
            Locale.get("Dashboard.lineChart.xAxisTitle"),
            Locale.get("Dashboard.lineChart.yAxisTitle_2"),
            "month",
            "value"
            // "advisee"
          )}
        </Col>
        <Col xs={24} md={24} xl={12}>
          {LineChartLabel(
            data.deals,
            Locale.get("Dashboard.lineChart.chartTitle_3"),
            Locale.get("Dashboard.lineChart.xAxisTitle"),
            Locale.get("Dashboard.lineChart.yAxisTitle_3"),
            "month",
            "value"
            // "deals"
          )}
        </Col>
        <Col xs={24} md={24} xl={12}>
          {LineChartLabel(
            data.client,
            Locale.get("Dashboard.lineChart.chartTitle_4"),
            Locale.get("Dashboard.lineChart.xAxisTitle"),
            Locale.get("Dashboard.lineChart.yAxisTitle_4"),
            "month",
            "value"
            // "clients"
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LineChart;
